import { TextInput } from "@mantine/core";
import { IconCommand, IconSearch } from "@tabler/icons-react";
import { useRef } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { openCommandPalette } from "../CommandPalette/commandPaletteState";

interface SearchBarProps {
	onNodeSelected?: (nodeId: string) => void; // Kept for backward compatibility, unused
	hideShortcut?: boolean;
	fullWidth?: boolean;
}

/**
 * SearchBar acts as a trigger to open the unified command palette.
 * All search functionality (nodes, commands, views) is handled by CommandBar.
 *
 * Note: The onNodeSelected prop is kept for backward compatibility but is no longer used.
 * Node selection is now handled directly by CommandBar.
 */
export function SearchBar({ hideShortcut, fullWidth }: SearchBarProps) {
	const inputRef = useRef<HTMLInputElement>(null);
	const isMobile = useIsMobile();

	const handleClick = () => {
		openCommandPalette();
	};

	const handleFocus = () => {
		openCommandPalette();
		// Blur the input to prevent focus restoration from modal triggering reopen
		inputRef.current?.blur();
	};

	const placeholder = isMobile
		? "Search..."
		: "Search nodes, commands, views...";
	const showShortcut = !hideShortcut && !isMobile;

	return (
		<TextInput
			ref={inputRef}
			readOnly
			placeholder={placeholder}
			leftSection={<IconSearch size={16} />}
			rightSection={
				showShortcut ? (
					<div
						className="flex items-center gap-1 text-xs text-gray-500 dark:text-gray-400"
						style={{ marginRight: "8px" }}
					>
						<IconCommand size={14} />
						<span>K</span>
					</div>
				) : undefined
			}
			rightSectionWidth={showShortcut ? "auto" : undefined}
			onClick={handleClick}
			onFocus={handleFocus}
			styles={{
				root: {
					width: "100%",
					maxWidth: fullWidth ? undefined : "400px",
				},
				input: {
					cursor: "pointer",
				},
			}}
		/>
	);
}
